import type { BankAccountType } from '@api';
import { Stack, Text } from '@mantine/core';

type DepositBankAccountLabelPropsType = {
  bankAccount: BankAccountType;
};

export const DepositBankAccountLabel: React.FC<
  DepositBankAccountLabelPropsType
> = ({ bankAccount }) => {
  const line2 = bankAccount.iban ?? bankAccount.accountNumber ?? '';

  return (
    <Stack gap={0}>
      <Text size="sm">{bankAccount.accountHolderName}</Text>
      {line2 ? (
        <Text size="sm" c="dimmed">
          {line2}
        </Text>
      ) : null}
    </Stack>
  );
};
